import { render, staticRenderFns } from "./SecondConfirm.vue?vue&type=template&id=ec827138&scoped=true&"
import script from "./SecondConfirm.vue?vue&type=script&lang=js&"
export * from "./SecondConfirm.vue?vue&type=script&lang=js&"
import style0 from "./SecondConfirm.vue?vue&type=style&index=0&id=ec827138&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec827138",
  null
  
)

export default component.exports